import React, { type ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import { useClavierVisible } from '../hooks/useClavierVisible';
import { colors, screenPadding, spacing } from '../theme/tokens';

export interface PiedActionProps {
  children: ReactNode;
  testID?: string;
  /** Posé dans une colonne de page (ordinateur) : sans fond, filet ni marge latérale. */
  enColonne?: boolean;
}

/**
 * Barre d'action fixe des écrans de saisie : phrase d'état et bouton principal, SOUS le défilement
 * (jamais par-dessus, rien n'est masqué). Rangée tant que le clavier est ouvert : sur un petit
 * téléphone, elle prendrait la moitié de la hauteur utile au champ qu'on remplit.
 */
export function PiedAction({ children, testID, enColonne = false }: PiedActionProps) {
  const clavier = useClavierVisible();
  if (clavier) return null;
  return (
    <View testID={testID} style={[styles.pied, enColonne && styles.piedColonne]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  piedColonne: { paddingHorizontal: 0, paddingTop: 0, paddingBottom: 0, backgroundColor: 'transparent', borderTopWidth: 0 },
  pied: {
    gap: spacing.sm - 2,
    paddingHorizontal: screenPadding,
    paddingTop: spacing.md,
    paddingBottom: spacing.lg,
    backgroundColor: colors.white,
    borderTopWidth: 1,
    borderTopColor: colors.grey200,
  },
});
